import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { BzObjType } from '../Enums/BzObjType.enum';
import { EMode } from '../Enums/EMode.enum';

export class PositionConversionHistory<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: number;
  /** Alias: positionCode */
  positionCode?: number;
  /** Alias: originalPositionCode */
  originalPositionCode?: number;
  /** Alias: originalBzObjType */
  originalBzObjType?: BzObjType;

  __typename?: string;
}

const fields: FieldDefinitions<PositionConversionHistory> = {
  id: {
    alias: 'id',
  },
  positionCode: {
    alias: 'positionCode',
  },
  originalPositionCode: {
    alias: 'originalPositionCode',
  },
  originalBzObjType: {
    alias: 'originalBzObjType',
  },
  __typename: {
    alias: '__typename',
  },
};

export const positionConversionHistoryEntityDefinition: EntitiyDefinition<PositionConversionHistory> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'PositionConversionHistory',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
